import {
  getGradingCommentTemplatesField,
  getLearningCourseField,
} from "./modules/utils";

const GenericCurriculumProgramPolicy = {
  GenericCurriculumProgram: {
    fields: {
      gradingCommentTemplates: getGradingCommentTemplatesField(),
      learningCourse: getLearningCourseField(),
    },
  },
};

export default GenericCurriculumProgramPolicy;
